import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { addData, deleteData, loadData, updateData } from "../../../../config/data";
import EmptyAsset from "../emptyAsset";
import Lang from "../../../../config/lang";
import '../../../../index.css'
import { useProfileTab } from "../../ProfileTabContext";

const WorkExperienceForm = ({ setIsFading, updatePercentage, profileCompletion, setprofileData, profileData }) => {
  const { lang } = useSelector((state) => state.globalReducer);
  const { currentTabIndex, setCurrentTabIndex } = useProfileTab();

  const [isEdit, setisEdit] = useState(false);
  const [experiences, setExperiences] = useState([]);
  const [isLoading, setisLoading] = useState('');
  const [isHasWorkExp, setisHasWorkExp] = useState(null);
  const applicantID = localStorage?.getItem("applicantID");
  const userToken = localStorage?.getItem('authToken') || '';

  const loadJobata = async () => {
    loadData({
      url: `WorkExperience`,
      params: [{ title: "filter", value: `applicant:${applicantID}` }],
      userToken,
    }).then(async (res) => {
      if (res?.data) {
        const resData = res.data;
        const sortedData = [...resData].sort(
          (a, b) => new Date(b.employmentStartDate) - new Date(a.employmentStartDate)
        );
        setExperiences(sortedData);
      }
    });
  };

  useEffect(() => {
    if (profileData.hasWorkExperience !== null && profileData.hasWorkExperience !== undefined) {
      setisHasWorkExp(profileData.hasWorkExperience)
    }
  }, [])


  const isFormReady = () => {
    const hasEmptyId = experiences.some(item => !item.companyName || !item.lastPosition || !item.industry || !item.employmentStartDate || !(item.employmentEndDate || item.isCurrentJob));
    return !hasEmptyId && (experiences.length === 0 ? (isHasWorkExp === false) : true);
  }


  const isDescLengthReady = () => {
    const isLengthReady = experiences.some(item => (-1 * ((item.reasonForLeaving || '').length - 255)) >= 0 && (-1 * ((item.jobDescription || '').length - 3000)) >= 0 && (-1 * ((item.companyAddress || '').length - 255)) >= 0);
    return isHasWorkExp !== true ? true : isLengthReady;
  }


  useEffect(() => {
    loadJobata();
  }, []);

  // Handle field change
  const handleChange = (index, field, value) => {
    const updated = [...experiences];
    updated[index][field] = value;
    setExperiences(updated);
  };

  // Add new work experience
  const handleAdd = () => {
    setisEdit(true)
    setprofileData({
      ...profileData,
      hasWorkExperience: false
    });
    setisHasWorkExp(true)
    setExperiences([
      ...experiences,
      {
        "companyName": "",
        "industry": "",
        "companyAddress": "",
        "companyPhoneNumber": "",
        "jobDescription": "",
        "lastPosition": "",
        "employmentStartDate": "",
        "employmentEndDate": "",
        "lastSalary": null,
        "reasonForLeaving": "",
        "isCurrentJob": false
      }
    ]);
  };


  const saveExperience = async (exp) => {
    try {
      if (exp.experienceID) {
        await updateData({
          url: "WorkExperience",
          userToken,
          reqBody:
          {
            experienceID: exp.experienceID || undefined,
            applicantID: applicantID,
            companyName: exp.companyName,
            industry: exp.industry,
            companyAddress: exp.companyAddress,
            companyPhoneNumber: exp.companyPhoneNumber,
            jobDescription: exp.jobDescription,
            lastPosition: exp.lastPosition,
            employmentStartDate: exp.employmentStartDate,
            employmentEndDate: exp.employmentEndDate,
            lastSalary: exp.lastSalary,
            reasonForLeaving: exp.reasonForLeaving,
            canBeContacted: true,
            isCurrentJob: exp.isCurrentJob,
          }
        })

      } else {
        await addData({
          url: "WorkExperience",
          userToken,
          reqBody: {
            experienceID: exp.experienceID || undefined,
            applicantID: applicantID,
            companyName: exp.companyName,
            industry: exp.industry,
            companyAddress: exp.companyAddress,
            companyPhoneNumber: exp.companyPhoneNumber,
            jobDescription: exp.jobDescription,
            lastPosition: exp.lastPosition,
            employmentStartDate: exp.employmentStartDate,
            employmentEndDate: exp.employmentEndDate,
            lastSalary: exp.lastSalary,
            reasonForLeaving: exp.reasonForLeaving,
            canBeContacted: true,
            isCurrentJob: exp.isCurrentJob,
          }
        });
      }

    } catch (error) {

      console.error("Failed to save work experience:", error);
    }
  };

  const handleSave = async () => {
    setisLoading(true)
    for (let exp of experiences) {
      await saveExperience(exp);
    }
    if (isHasWorkExp === true) {
      setprofileData({
        ...profileData,
        hasWorkExperience: true
      });
    } else {
      setprofileData({
        ...profileData,
        hasWorkExperience: false
      });
    }
    await updateData({
      url: 'Applicants',
      userToken,
      reqBody: {
        ...profileData,
        hasWorkExperience: isHasWorkExp
      },
    }).then(res => {
      console.log('res', JSON.stringify(res))
    })

    setisEdit(false);
    loadJobata();
    setisLoading(false)
  };

  const handleDelete = async (index, exp) => {
    try {
      if (exp.experienceID) {
        await deleteData(
          { url: 'WorkExperience', id: exp.experienceID, userToken }
        );
      }
      setExperiences(experiences.filter((_, i) => i !== index));
    } catch (error) {
      console.error("Failed to delete work experience:", error);
    }
  };

  return (
    <div>
      <div className="mt-4 bg-white p-6 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)]" style={{ minHeight: window.innerHeight - 300 }}>
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-blue-700 font-medium md:text-[20px] text-[17px] flex items-center space-x-2 cursor-pointer">
              <img src={"/asset/icon/job_blue.svg"} className="w-[16px] mr-1" />
              <span>{Lang(lang, 'work_xperience')}</span>
            </h2>
            <p className="text-[11px] md:text-[14px] font-normal text-[#1E3A8A]">{Lang(lang, 'work_exp_subtitle')}</p>
          </div>
          {!isEdit && (
            <button
              onClick={() => setisEdit(true)}
              className="flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 hover:bg-red-600"
            >
              <img src={"/asset/icon/edit.svg"} className="w-[16px] mr-1" />
              Edit
            </button>
          )}
        </div>

        <form className="space-y-6">
          {experiences.length === 0 ?
            <div className="flex flex-col w-full items-start">
              <div className="flex flex-row mt-20">
                <label className="flex items-center space-x-2 mx-auto flex flex-row">
                  <input
                    type="checkbox"
                    disabled={!isEdit}
                    name="experience"
                    value="hasExperience"
                    className="form-radio text-red-500 mb-1"
                    checked={isHasWorkExp === false}
                    onChange={(e) => {
                      setisHasWorkExp(isHasWorkExp === false ? true : false);
                      console.log('isHasWorkExp:', isHasWorkExp)
                    }}
                  />
                  <span className="text-gray-700">{Lang(lang, 'haveNoJobExp')}</span>
                </label>
              </div>
              {isEdit && <button
                type="button"
                onClick={handleAdd}
                className="mt-5 w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
              >
                + {Lang(lang, 'add_work_exp')}
              </button>}
            </div> : experiences.map((exp, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-xl p-4 relative text-sm"
              >
                {isEdit && (
                  <button
                    type="button"
                    onClick={() => handleDelete(index, exp)}
                    className="absolute top-3 right-3 text-red-500 hover:text-red-700"
                  >
                    <img src={"/asset/icon/trash.svg"} className="w-[16px]" />
                  </button>
                )}

                <h3 className="text-gray-700 font-bold text-[#1E40AF] mb-3">
                  {Lang(lang, 'experience')} {index + 1}
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                  <div>
                    <label className="block font-medium mb-1">{Lang(lang, 'position')}<span className="text-red-500">*</span></label>
                    <input
                      disabled={!isEdit}
                      type="text"
                      value={exp.lastPosition || ""}
                      onChange={(e) =>
                        handleChange(index, "lastPosition", e.target.value)
                      }
                      className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                      placeholder={Lang(lang, 'position')}
                    />
                  </div>

                  <div>
                    <label className="block font-medium mb-1">{Lang(lang, 'company')}<span className="text-red-500">*</span></label>
                    <input
                      disabled={!isEdit}
                      type="text"
                      value={exp.companyName || ""}
                      onChange={(e) =>
                        handleChange(index, "companyName", e.target.value)
                      }
                      className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                      placeholder={Lang(lang, 'company')}
                    />
                  </div>
                  <div>
                    <label className="block font-medium mb-1">{Lang(lang, 'sector')}<span className="text-red-500">*</span></label>
                    <input
                      disabled={!isEdit}
                      type="text"
                      value={exp.industry || ""}
                      onChange={(e) =>
                        handleChange(index, "industry", e.target.value)
                      }
                      className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                      placeholder={Lang(lang, 'sector')}
                    />
                  </div>

                  <div>
                    <label className="block font-medium mb-1">{Lang(lang, 'start_date')}<span className="text-red-500">*</span></label>
                    <input
                      disabled={!isEdit}
                      type="month"
                      value={
                        exp.employmentStartDate
                          ? `${exp.employmentStartDate}`.split("T")[0].slice(0, 7)
                          : ""
                      }
                      onChange={(e) =>
                        handleChange(index, "employmentStartDate", e.target.value)
                      }
                      className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                    />
                  </div>

                  <div>
                    <div className="flex flex-row justify-between">
                      <label className="block font-medium mb-1 items-center justify-between flex">{Lang(lang, 'end_date')}<span className="text-red-500">*</span>
                      </label>
                      <div>
                        <input
                          type="checkbox"
                          disabled={!isEdit}
                          className="form-checkbox text-red-500 mb-1 ml-4"
                          checked={exp.isCurrentJob === true}
                          onChange={(e) => {
                            if (exp.isCurrentJob !== true) {
                              handleChange(index, "employmentEndDate", "")
                            }
                            handleChange(index, "isCurrentJob", exp.isCurrentJob === true ? false : true)
                          }}
                        />
                        <span className="text-gray-700 ml-2">{Lang(lang, 'isMyCurrentJob')}</span>
                      </div>
                    </div>
                    <input
                      disabled={!isEdit || exp.isCurrentJob === true}
                      type="month"
                      value={
                        exp.employmentEndDate
                          ? `${exp.employmentEndDate}`.split("T")[0].slice(0, 7)
                          : ""
                      }
                      onChange={(e) =>
                        handleChange(index, "employmentEndDate", e.target.value)

                      }
                      className={(isEdit && exp.isCurrentJob !== true ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                    />
                  </div>

                  <div className="">
                    <label className="block font-medium mb-1">
                      {Lang(lang, 'base_salary')}
                    </label>
                    <input
                      disabled={!isEdit}
                      type={isEdit ? "number" : "text"}
                      inputMode="numeric"
                      onkeydown="return event.key !== 'e' && event.key !== 'E'"
                      readOnly={!isEdit}
                      value={isEdit
                        ? exp.lastSalary || ""
                        : exp.lastSalary
                          ? new Intl.NumberFormat("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            minimumFractionDigits: 0,
                          }).format(exp.lastSalary)
                          : ""
                      }
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/[^0-9]/g, '');
                        e.target.value = numericValue;
                        handleChange(index, "lastSalary", e.target.value)
                      }}
                      className={(isEdit ? 'bg-white' : 'bg-gray-100') + " appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                      placeholder="Last Salary"
                    />
                  </div>

                  <div className="md:col-span-3">
                    <label className="block font-medium mb-1">
                      {Lang(lang, 'company_address')}
                    </label>
                    <textarea
                      disabled={!isEdit}
                      value={exp.companyAddress || ""}
                      onChange={(e) =>
                        handleChange(index, "companyAddress", e.target.value)
                      }
                      rows={3}
                      className={"w-full rounded-xl border border-gray-300 p-2 text-xs resize-none " + (isEdit ? 'bg-white' : 'bg-gray-100')}
                      placeholder="Company Address"
                    />

                    {<div className="flex justify-end w-full">
                      <p className={(-1 * ((exp.companyAddress || '').length - 255)) < 0 ? "text-red-500 text-xs mt-1 mr-0" : "text-xs mt-1 mr-0"}>{-1 * ((exp.companyAddress || '').length - 255)}/255</p>
                    </div>}
                  </div>
                  <div className="md:col-span-3">
                    <label className="block font-medium mb-1">
                      {Lang(lang, 'job_description')}
                    </label>
                    <textarea
                      disabled={!isEdit}
                      value={exp.jobDescription || ""}
                      onChange={(e) =>
                        handleChange(index, "jobDescription", e.target.value)
                      }
                      rows={3}
                      className={"w-full rounded-xl border border-gray-300 p-2 text-xs resize-none " + (isEdit ? 'bg-white' : 'bg-gray-100')}
                      placeholder="Job Description"
                    />

                    {<div className="flex justify-end w-full">
                      <p className={(-1 * ((exp.jobDescription || '').length - 3000)) < 0 ? "text-red-500 text-xs mt-1 mr-0" : "text-xs mt-1 mr-0"}>{-1 * ((exp.jobDescription || '').length - 3000)}/3000</p>
                    </div>}
                  </div>
                  <div className="md:col-span-3">
                    <label className="block font-medium mb-1">
                      {Lang(lang, 'leaving_reason')}
                    </label>
                    <textarea
                      disabled={!isEdit}
                      value={exp.reasonForLeaving || ""}
                      onChange={(e) =>
                        handleChange(index, "reasonForLeaving", e.target.value)
                      }
                      rows={3}
                      className={"w-full rounded-xl border border-gray-300 p-2 text-xs resize-none " + (isEdit ? 'bg-white' : 'bg-gray-100')}
                      placeholder="Reason for Leaving"
                    />
                    {<div className="flex justify-end w-full">
                      <p className={(-1 * ((exp.reasonForLeaving || '').length - 255)) < 0 ? "text-red-500 text-xs mt-1 mr-0" : "text-xs mt-1 mr-0"}>{-1 * ((exp.reasonForLeaving || '').length - 255)}/255</p>
                    </div>}
                  </div>

                </div>
              </div>
            ))}

          <div className="flex justify-between items-center">
            {isEdit && experiences.length !== 0 && (
              <button
                type="button"
                onClick={handleAdd}
                className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
              >
                + {Lang(lang, 'add_work_exp')}
              </button>
            )}
          </div>
        </form>

        {!(isFormReady()) && <div className="flex justify-end w-full">
          <p className="text-red-500 text-xs mt-1 mr-0">{(experiences.length === 0 && (profileData.hasWorkExperience === null || profileData.hasWorkExperience === undefined)) ? Lang(lang, 'chooseWorkExpStatus') : (experiences.length === 0 && profileData.hasWorkExperience === false) ? Lang(lang, 'inputWorkExp') : Lang(lang, 'required_error')}</p>
        </div>}

      </div>
      <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3">
        <button
          type="button"
          className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
          onClick={() => {
            setIsFading(true);
            setTimeout(() => {
              setCurrentTabIndex(currentTabIndex - 1);
              setIsFading(false);
            }, 200);
          }}
        >
          {Lang(lang, 'previous')}
        </button>
        <button
          type="button"
          className={
            "rounded-full px-4 py-1 text-sm " +
            (isEdit && isFormReady() && isDescLengthReady()
              ? "text-white bg-red-500 hover:bg-red-600"
              : "border border-red-500 text-red-500 hover:bg-gray-50")
          }
          onClick={async () => {
            if (isFormReady() && isDescLengthReady()) {
              if (isEdit && !isLoading) {
                await handleSave();
                setIsFading(true);
                setTimeout(() => {
                  if ((currentTabIndex + 1) > profileCompletion) {
                    updatePercentage(currentTabIndex + 1)
                  }
                  setCurrentTabIndex(currentTabIndex + 1);
                  setIsFading(false);
                }, 200);
              } else {
                console.log('SALAH')
                setIsFading(true);
                setTimeout(() => {
                  if ((currentTabIndex + 1) > profileCompletion) {
                    updatePercentage(currentTabIndex + 1)
                  }
                  setCurrentTabIndex(currentTabIndex + 1);
                  setIsFading(false);
                }, 200);
              }
            }
          }}
        >
          {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" /> : isEdit ? Lang(lang, 'save_and_next') : `${Lang(lang, 'next')} ${currentTabIndex + 1}/10`}
        </button>
      </div>
    </div>
  );
};

export default WorkExperienceForm;
